import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchDeliveryProcess(service_provider_id, delivery_process_id) {
    return RequesterV1.get(
      `service_provider/delivery/managing/${service_provider_id}/show_process/${delivery_process_id}`
    );
  },

  fetchOrders(
    service_provider_id,
    delivery_process_id,
    currentPage,
    rowsPerPage
  ) {
    return RequesterV1.get(
      `service_provider/delivery/managing/${service_provider_id}/show_process/${delivery_process_id}/fetch_orders?current_page=${currentPage}&rows_per_page=${rowsPerPage}`
    );
  },

  fetchDeliveries(
    service_provider_id,
    delivery_process_id,
    currentPage,
    rowsPerPage
  ) {
    return RequesterV1.get(
      `service_provider/delivery/managing/${service_provider_id}/show_process/${delivery_process_id}/fetch_deliveries?current_page=${currentPage}&rows_per_page=${rowsPerPage}`
    );
  },

  fetchDeliveryCollections(
    service_provider_id,
    delivery_process_id,
    currentPage,
    rowsPerPage
  ) {
    return RequesterV1.get(
      `service_provider/delivery/managing/${service_provider_id}/show_process/${delivery_process_id}/fetch_delivery_collections?current_page=${currentPage}&rows_per_page=${rowsPerPage}`
    );
  },

  fetchDeliveryProcessProviders(
    service_provider_id,
    delivery_process_id,
    currentPage,
    rowsPerPage
  ) {
    return RequesterV1.get(
      `service_provider/delivery/managing/${service_provider_id}/show_process/${delivery_process_id}/fetch_delivery_process_providers?current_page=${currentPage}&rows_per_page=${rowsPerPage}`
    );
  },
};
